// extracted by mini-css-extract-plugin
export default {"wrapper":"DetailNetworking_wrapper__isFJs","col":"DetailNetworking_col__hjmB0"};